import React, { useEffect } from 'react';
import { useTranslate } from 'react-translate';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, CardTitle, CardHeader } from 'reactstrap';
import { actionRequestStudyTypes } from 'store/actions/analysisActions';
import UploadForm from 'components/Laboratories/Upload/UploadForm';

const LaboratoryManualUpload = () => {
  const t = useTranslate('study-upload');
  const dispatch = useDispatch();
  const studyTypes = useSelector(state => state.analysisReducer.studyTypes);
  const { mobile } = useSelector(
    (state) => state.commonReducer
  );

  useEffect(() => {
    if (!studyTypes.length) {
      dispatch(actionRequestStudyTypes());
    }
  }, [dispatch]);

  return (
    <div className="d-flex">
      <Card>
        <CardBody>
          <Card>
            <CardHeader>
              <CardTitle className="d-flex align-content-center">
                <div className="general-card-title-img text-primary mr-2">
                  {/*<i className="icon-inbox-header" />*/}
                </div>
                <div className="general-card-title text-primary">
                  {t("form-title")}
                </div>
              </CardTitle>
            </CardHeader>
            <CardBody className="justify-content-center">
              <div className="d-flex justify-content-center">
                <div style={{minWidth: mobile ? "100%" : "70%"}}>
                  <UploadForm />
                </div>
              </div>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </div>
  );
};

export default LaboratoryManualUpload;
